<template>
  <div class="el-main">
    <MyprofileFavoritesCard
      :format-id="formatId"
      :current-card-id="currentCardId"
    />
    <MyprofileBest3Card
      :format-id="formatId"
      :current-card-id="currentCardId"
    />
    <MyprofileTypesCard
      :format-id="formatId"
      :current-card-id="currentCardId"
    />
    <RirekishoEduHistoryCard
      :basic-data="basicData"
      :format-id="formatId"
      :current-card-id="currentCardId"
      :preview-errors="previewErrors"
    />
    <RirekishoJobHistoryCard
      :basic-data="basicData"
      :format-id="formatId"
      :current-card-id="currentCardId"
      :preview-errors="previewErrors"
    />
    <MyprofileFreespaceCard
      :format-id="formatId"
      :current-card-id="currentCardId"
    />
    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>作成した履歴書を確認</h2>
          <p>ステップに戻って修正することができます</p>
        </div>
      </div>
    </div>
    <MyprofileOutputCard
      :format-id="formatId"
      :current-card-id="currentCardId"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, watch } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import { provideRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import {
  provideRirekishoHistories,
  useRirekishoHistories
} from '@/composables/format-edit/useRirekishoHistories'
import MyprofileFavoritesCard from '@/components/format-edit/myprofile/MyprofileFavoritesCard.vue'
import MyprofileBest3Card from '@/components/format-edit/myprofile/MyprofileBest3Card.vue'
import MyprofileTypesCard from '@/components/format-edit/myprofile/MyprofileTypesCard.vue'
import MyprofileFreespaceCard from '@/components/format-edit/myprofile/MyprofileFreespaceCard.vue'
import MyprofileOutputCard from '@/components/format-edit/myprofile/MyprofileOutputCard.vue'
import RirekishoEduHistoryCard from '@/components/format-edit/rirekisho/RirekishoEduHistoryCard.vue'
import RirekishoJobHistoryCard from '@/components/format-edit/rirekisho/RirekishoJobHistoryCard.vue'
import type { BasicData } from '@/utils/format-edit/basicData'
import {
  createEmptyMyprofileFormatData,
  migrateMyprofileFormatData
} from '@/utils/format-edit/myprofileFields'

const props = defineProps<{
  basicData: BasicData
  formatId?: string
  previewFormat?: {
    errorMessages?: Record<string, string>
  } | null
  currentCardId?: string
  exampleSentences?: Record<string, unknown>
}>()

const { formLib } = useHostServices()

const { formatData, saveKey, saveName, changeCount } = useFormatLocalData({
  saveName: 'rirekisho',
  saveOtherName: 'shokumukeirekisho',
  createEmpty: createEmptyMyprofileFormatData,
  migrate: migrateMyprofileFormatData
})
provideRirekishoFormatData(formatData)

const histories = useRirekishoHistories(formatData)
provideRirekishoHistories(histories)

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = formLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
})

defineExpose({
  saveName,
  saveKey,
  formatData,
  changeCount,
  addEducationalHistory: histories.addEducationalHistory
})
</script>

<style lang="scss" scoped>
* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}
</style>
